import { Reader, Writer } from "protobufjs/minimal";
import type {
  ProductTilePreferences_TileSizes,
  ProductTilePreferences,
} from "../../aysa_api/models/product_tile_preferences.types";
import {
  encodeProductImageTypes,
  decodeProductImageTypes,
} from "../../aysa_api/models/product_images";

export const decodeProductTilePreferences_TileSizes = (
  reader: Reader
): ProductTilePreferences_TileSizes => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    default:
      return 0;
  }
};

export const encodeProductTilePreferences_TileSizes = (
  writer: Writer,
  value: ProductTilePreferences_TileSizes
): Writer => {
  return writer.int32(value);
};

export const createBaseProductTilePreferences = (): ProductTilePreferences => {
  return {
    showProductNames: false,
    preferredProductImageType: 0,
    preferredTileSize: 0,
  };
};

export const decodeProductTilePreferences = (
  reader: Reader,
  length: number
): ProductTilePreferences => {
  const end = reader.pos + length;
  const message = createBaseProductTilePreferences();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.showProductNames = reader.bool();

        break;
      case 3:
        message.preferredProductImageType = decodeProductImageTypes(reader);

        break;
      case 4:
        message.preferredTileSize =
          decodeProductTilePreferences_TileSizes(reader);

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductTilePreferences = (
  writer: Writer,
  message: ProductTilePreferences
): Writer => {
  writer.uint32(8).bool(message.showProductNames);
  encodeProductImageTypes(writer.uint32(24), message.preferredProductImageType);
  encodeProductTilePreferences_TileSizes(
    writer.uint32(32),
    message.preferredTileSize
  );

  return writer;
};
